import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../../infra/hooks";

interface Props {
  setLockScreenData: (data: any) => void;
}
function DTOEmployeeLockScreen({ setLockScreenData }: Props) {
  const selector = useAppSelector((state) => state.personalInfoSlice);
  const profilePic = useAppSelector(
    (state) => state.profilePicSlice.profilePic
  );

  useEffect(() => {
    setLockScreenData({
      fullname: selector.firstName + " " + selector.lastName,
      profile_pic: profilePic,
    });
  }, [profilePic, selector]);
  return <></>;
}
export default DTOEmployeeLockScreen;
